import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'sm' | 'md';
  variant?: 'default' | 'danger';
  label: string;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, size = 'md', variant = 'default', label, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        aria-label={label}
        title={label}
        className={cn(
          'focus-ring inline-flex shrink-0 items-center justify-center rounded-full bg-white/10 text-text-primary transition-colors duration-fast hover:bg-white/[0.18] disabled:cursor-not-allowed disabled:opacity-40',
          size === 'sm' ? 'h-8 w-8' : 'h-10 w-10',
          variant === 'danger' && 'hover:bg-state-error/20 hover:text-state-error',
          className,
        )}
        {...props}
      >
        {children}
      </button>
    );
  },
);
IconButton.displayName = 'IconButton';
